@if (organizations && visible === true) {
	<form class="container without-default-focus">
		<fa-icon [icon]="faFilter"></fa-icon>
		<label>Organisations :</label>
		<div>
			<input #selectControl type="text" placeholder="" aria-label="Number" matInput [formControl]="selectFormControl" [matAutocomplete]="auto" (focusout)="onFocusOut()" />
			<mat-autocomplete
				#auto="matAutocomplete"
				[displayWith]="displayLabel"
				(opened)="opened()"
				(closed)="closed()"
				class="organization-autocomplete"
				panelWidth="fit-content">
				@for (organization of filteredOrganizations | async; track organization) {
					<mat-option [value]="organization">
						{{ organization.name }}
					</mat-option>
				}
			</mat-autocomplete>
			<fa-icon [icon]="faCaretDown" (click)="selectControl.focus()"></fa-icon>
		</div>
	</form>
}
